<script>
    // Скупщик рыбы (и вообще рыболовный магазин) — Emerald.
    // Открытие: router.setView('FishingStore', json) где json = Dictionary<категория, StoreItem[]>
    // (StoreItem: {Name, ItemId, Price, Value, IsSell, IsDonate}) — то, что шлёт сервер
    // в client.fishing.store.open. Действие: client.fishing.store.action(category, index, value).
    import { itemsInfo } from 'json/itemsInfo.js';
    import { executeClient } from 'api/rage';

    export let viewData = null;

    const CATEGORY_TITLES = {
        fishingCategoryRod: 'Удочки',
        fishingCategoryBait: 'Наживка',
        fishingCategoryFish: 'Скупка рыбы',
    };

    let data = {};
    $: {
        let d = viewData;
        if (typeof d === 'string') { try { d = JSON.parse(d); } catch (e) { d = {}; } }
        data = d && typeof d === 'object' ? d : {};
        const cats = Object.keys(data);
        if (!cats.includes(activeCat)) activeCat = cats[0] || '';
    }

    let activeCat = '';
    let counts = {}; // index -> выбранное кол-во

    $: items = data[activeCat] || [];

    const iconOf = (itemId) => {
        const info = itemsInfo[itemId];
        if (info && info.Icon && info.Icon.startsWith('http')) return info.Icon;
        if (info && info.Icon && info.Icon.startsWith('/')) return '.' + info.Icon; // /fishing_cdn/... -> ./fishing_cdn/...
        return document.cloud + 'inventoryItems/items/' + itemId + '.png'; // штатный путь иконок предметов
    };

    const ownedOf = (itemId) => {
        try { return window.getItemToCount ? window.getItemToCount(itemId) : 0; } catch (e) { return 0; }
    };

    const countOf = (index) => Math.max(1, counts[index] || 1);
    const setCount = (index, v, max) => {
        counts[index] = Math.min(Math.max(1, v), Math.max(1, max));
        counts = counts;
    };

    const onAction = (item, index) => {
        const value = item.IsSell ? Math.min(countOf(index), Math.max(1, ownedOf(item.ItemId))) : countOf(index);
        executeClient('client.fishing.store.action', activeCat, index, value);
        setTimeout(() => { counts = {}; }, 100); // обновить «у вас X шт» после операции
    };

    const onClose = () => {
        executeClient('client.fishing.store.close'); // клиент сам сделает router.setHud()
        if (window.mp === undefined) { try { window.router.close(); } catch (e) {} } // браузерное превью
    };

    const onKeyUp = (e) => { if (e.keyCode === 27) onClose(); };

    const fmt = (n) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
</script>
<svelte:window on:keyup={onKeyUp} />

<div class="jrstore">
    <div class="panel">
        <div class="head">
            <div class="title">
                <span class="logo">JR</span>
                <div>
                    <h1>Скупщик рыбы</h1>
                    <p>принимает улов · платит сразу</p>
                </div>
            </div>
            <button class="close" on:click={onClose}>✕</button>
        </div>

        {#if Object.keys(data).length > 1}
            <div class="tabs">
                {#each Object.keys(data) as cat}
                    <button class="tab" class:active={activeCat === cat} on:click={() => { activeCat = cat; counts = {}; }}>
                        {CATEGORY_TITLES[cat] || cat}
                    </button>
                {/each}
            </div>
        {/if}

        <div class="list">
            {#each items as item, index}
                {@const owned = (counts, ownedOf(item.ItemId))}
                <div class="row" class:dim={item.IsSell && owned < 1}>
                    <div class="icon">
                        {#if iconOf(item.ItemId)}
                            <img src={iconOf(item.ItemId)} alt="" />
                        {/if}
                    </div>
                    <div class="info">
                        <b>{item.Name}</b>
                        <span>
                            {#if item.IsSell}
                                у вас: <i class:has={owned > 0}>{owned} шт</i>
                            {:else}
                                в наличии
                            {/if}
                        </span>
                    </div>
                    <div class="price">
                        <b>{fmt(item.Price)}</b>
                        <span>{item.IsDonate ? 'JC' : '$'} / шт</span>
                    </div>
                    <div class="qty">
                        <button on:click={() => setCount(index, countOf(index) - 1, item.IsSell ? owned : 999)}>−</button>
                        <b>{item.IsSell ? Math.min(countOf(index), Math.max(1, owned)) : countOf(index)}</b>
                        <button on:click={() => setCount(index, countOf(index) + 1, item.IsSell ? owned : 999)}>+</button>
                        {#if item.IsSell && owned > 1}
                            <button class="all" on:click={() => setCount(index, owned, owned)}>всё</button>
                        {/if}
                    </div>
                    <button class="act" class:sell={item.IsSell} disabled={item.IsSell && owned < 1} on:click={() => onAction(item, index)}>
                        {item.IsSell ? 'Продать' : 'Купить'}
                    </button>
                </div>
            {/each}
            {#if !items.length}
                <div class="empty">Пусто</div>
            {/if}
        </div>

        <div class="foot">ESC — закрыть</div>
    </div>
</div>

<style>
    .jrstore {
        position: absolute; inset: 0;
        font-family: 'Gilroy', 'SF Pro Display', sans-serif;
        display: flex; align-items: center; justify-content: center;
        background: radial-gradient(80% 70% at 50% 45%, rgba(2, 12, 7, 0.25) 0%, rgba(2, 12, 7, 0.6) 100%);
        user-select: none;
    }
    .panel {
        width: 64vh; max-height: 76vh;
        display: flex; flex-direction: column;
        border-radius: 1.6vh;
        background: linear-gradient(165deg, rgba(8, 30, 18, 0.92), rgba(4, 16, 10, 0.95));
        border: 1px solid rgba(140, 255, 190, 0.18);
        box-shadow: 0 24px 70px rgba(0, 0, 0, 0.6);
        overflow: hidden;
    }
    .head {
        display: flex; align-items: center; justify-content: space-between;
        padding: 2vh 2.4vh 1.6vh;
    }
    .title { display: flex; align-items: center; gap: 1.4vh; }
    .logo {
        width: 4.6vh; height: 4.6vh; border-radius: 1vh; flex: none;
        display: flex; align-items: center; justify-content: center;
        font-weight: 800; font-size: 1.8vh; color: #04150c;
        background: linear-gradient(115deg, #36e07c, #9ef7bc);
        box-shadow: 0 4px 16px rgba(54, 224, 124, 0.3);
    }
    .title h1 {
        margin: 0; font-size: 2vh; font-weight: 800; letter-spacing: .08em;
        text-transform: uppercase; color: #ecfff3;
    }
    .title p { margin: .2vh 0 0; font-size: 1.25vh; color: rgba(220, 248, 232, 0.5); }
    .close {
        width: 3.6vh; height: 3.6vh; border-radius: .9vh; border: 0; cursor: pointer;
        background: rgba(255, 92, 92, 0.12); color: #ff8a80; font-size: 1.6vh;
        transition: background .15s;
    }
    .close:hover { background: rgba(255, 92, 92, 0.25); }

    .tabs { display: flex; gap: .8vh; padding: 0 2.4vh 1.4vh; }
    .tab {
        padding: .8vh 1.6vh; border-radius: .9vh; border: 0; cursor: pointer;
        font-family: inherit; font-size: 1.35vh; font-weight: 800;
        color: rgba(236, 255, 243, 0.7); background: rgba(140, 255, 190, 0.07);
        transition: background .15s, color .15s;
    }
    .tab:hover { background: rgba(54, 224, 124, 0.14); }
    .tab.active { background: linear-gradient(115deg, #36e07c, #9ef7bc); color: #04150c; }

    .list { overflow-y: auto; padding: 0 2.4vh; }
    .list::-webkit-scrollbar { width: 4px; }
    .list::-webkit-scrollbar-thumb { background: rgba(140, 255, 190, 0.22); border-radius: 4px; }

    .row {
        display: flex; align-items: center; gap: 1.6vh;
        padding: 1.1vh 1.2vh; margin-bottom: .8vh;
        border-radius: 1vh;
        background: rgba(10, 36, 22, 0.45);
        border: 1px solid rgba(140, 255, 190, 0.1);
        transition: border-color .15s, background .15s;
    }
    .row:hover { border-color: rgba(54, 224, 124, 0.35); background: rgba(13, 46, 28, 0.55); }
    .row.dim { opacity: .45; }
    .icon {
        width: 5.6vh; height: 5.6vh; flex: none; border-radius: .8vh;
        background: rgba(4, 18, 11, 0.6); display: flex; align-items: center; justify-content: center;
    }
    .icon img { max-width: 86%; max-height: 86%; filter: drop-shadow(0 2px 6px rgba(0,0,0,.5)); }
    .info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: .3vh; }
    .info b { font-size: 1.55vh; font-weight: 800; color: #ecfff3; }
    .info span { font-size: 1.2vh; color: rgba(220, 248, 232, 0.5); }
    .info i { font-style: normal; color: rgba(255, 138, 128, 0.9); }
    .info i.has { color: #9ef7bc; }
    .price { text-align: right; flex: none; display: flex; flex-direction: column; }
    .price b { font-size: 1.6vh; font-weight: 800; color: #ffd166; }
    .price span { font-size: 1.05vh; color: rgba(220, 248, 232, 0.45); }
    .qty { display: flex; align-items: center; gap: .6vh; flex: none; }
    .qty button {
        width: 2.8vh; height: 2.8vh; border-radius: .6vh; border: 0; cursor: pointer;
        background: rgba(140, 255, 190, 0.1); color: #9ef7bc; font-size: 1.5vh; font-weight: 800;
        transition: background .15s;
    }
    .qty button:hover { background: rgba(54, 224, 124, 0.25); }
    .qty button.all { width: auto; padding: 0 .9vh; font-size: 1.1vh; }
    .qty b { min-width: 3vh; text-align: center; font-size: 1.5vh; color: #ecfff3; font-variant-numeric: tabular-nums; }
    .act {
        flex: none; padding: 1vh 1.8vh; border-radius: .9vh; border: 0; cursor: pointer;
        font-family: inherit; font-size: 1.35vh; font-weight: 800; color: #04150c;
        background: linear-gradient(115deg, #36e07c, #9ef7bc);
        box-shadow: 0 4px 14px rgba(54, 224, 124, 0.25);
        transition: filter .15s;
    }
    .act:hover { filter: brightness(1.08); }
    .act.sell { background: linear-gradient(115deg, #ffd166, #ffe3a0); box-shadow: 0 4px 14px rgba(255, 209, 102, 0.25); }
    .act:disabled { filter: grayscale(1) brightness(.6); cursor: default; }

    .empty { padding: 4vh 0; text-align: center; color: rgba(220, 248, 232, 0.4); font-size: 1.5vh; }
    .foot { padding: 1.2vh 2.4vh 1.6vh; font-size: 1.1vh; letter-spacing: .1em; text-transform: uppercase; color: rgba(220, 248, 232, 0.35); text-align: center; }
</style>
